import React, { Fragment } from 'react';
import { Image } from '../../../AbstractElements';
import { Media } from 'reactstrap';
import { JohnLoren, myfavorite } from '../../../Constant';

import user from '../../../assets/images/user/12.png';
const CurrentUser = () => {
  return (
    <Fragment>
      <Media className='d-flex'>
        <Image src={user} className='rounded-circle user-image' />
        <div className='about'>
          <div className='name f-w-600'>{JohnLoren}</div>
          <div className='status'>{myfavorite}</div>
        </div>
      </Media>
    </Fragment>
  );
};

export default CurrentUser;
